import { trackEvent } from '@pb/utils'

import { ACCOUNT_TRACKING_EVENTS } from 'features/account/constants'

import requests from '../requests'
import actions from './actions'
import { News } from './types'

export const operationFetchNews = () => (dispatch) => {
  dispatch(actions.fetchNewsStart())

  requests
    .fetchNews()
    .then((news: News[]) => {
      dispatch(actions.fetchNewsSuccess(news))
    })
    .catch(({ message }) => {
      dispatch(actions.fetchNewsFail(message))
      trackEvent({
        ...ACCOUNT_TRACKING_EVENTS.newsError.data,
        event_label: message,
      })
    })
}
